import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors'
import * as background from '../../config/backgroundColor'
import * as legend from '../../config/legend'
import * as series from '../../config/series'
import * as toolbox from '../../config/toolbox'
import * as tooltip from '../../config/tootip'
import * as xAxis from '../../config/xAxis'
import * as yAxis from '../../config/yAxis'
import * as brush from '../../config/brush';
import * as datazoom from '../../config/datazoom';
import { CommonService } from '../../service/common.service';
import { EChartOption } from 'echarts';
import * as grid from '../../config/grid';
import { BasicBarLineComponent } from './basic-bar-line.component';
import { cloneDeep, isNil } from 'lodash';
import { ChartOptionService } from '../../service/chart-option.service';
import { ECharts } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class BasicBarLineService {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService
  ) { }

  getBasicBarLineChartDefaultOption() {
    let style = this.commonService.changeFontSize();
    let option = {
      backgroundColor: background.backgroundColor,
      color: color.defaultColors,
      grid: style.interval,
      legend: legend.getLegendBottomScroll(style),
      toolbox: toolbox.getToolboxBasicMenu(),
      tooltip: tooltip.getCommonTooltipOfAxis(),
      xAxis: xAxis.getCategoryXAxis(style),
      yAxis: yAxis.getDoubleValueYAxis(style),
      series: series.getBarLineSeries(style)
    }
    return option;
  }

  // 更改toolbox显示状态
  changeToolboxShow(chartOpt, bcacLegendShow: boolean) {
    chartOpt.toolbox.show = bcacLegendShow;
  }

  // 更改图例位置
  changeLegendPosition(chartOpt, position: string) {
    let style = this.commonService.changeFontSize();

    switch (position) {
      case 'bottom':
        chartOpt.legend = legend.getLegendBottomScroll(style)
        chartOpt.grid = style.interval
        break;
      case 'above':
        chartOpt.legend = legend.getAboveBlock(style)
        chartOpt.grid = style.interval
        break;
      case 'right':
        chartOpt.legend = legend.getLegendRightScroll(style)
        chartOpt.grid = style.rightLegendGrid
        break;
    }
  }

  // 更改图例显示状态
  changeLegendShow(chartOpt, bcacLegendShow: boolean) {

    let option = _.cloneDeep(chartOpt);
    option.legend.show = bcacLegendShow;
    return option;
  }

  // 更改数据
  changeChartData(chartOpt, data) {
    let style = this.commonService.changeFontSize()
    chartOpt.xAxis[0].data = data.xData;
    chartOpt.series = series.getBarLineSeries(style, data)
  }

  // 更改tooltipUnit
  changeTooltipUnit(chartOpt, tooltipUnit: string | string[]) {
    chartOpt.tooltip = tooltip.getCommonTooltipOfAxis(tooltipUnit)
  }

  // 更改XAxisName
  changeXAxisName(chartOpt, xAxisName: string) {
    chartOpt.xAxis[0].name = xAxisName;
  }

  // 更改yAxisName
  changeYAxisName(chartOpt, yAxisName: string[]) {
    for (let i = 0; i < chartOpt.yAxis.length; i++) {
      chartOpt.yAxis[i].name = i < yAxisName.length ? yAxisName[i] : "";
    }
  }
  // 更改yAxisNameGap
  changeYAxisNameGap(chartOpt, yAxisNameGap: number) {
    for (let i = 0; i < chartOpt.yAxis.length; i++) {
      chartOpt.yAxis[i].nameGap = yAxisNameGap;
    }
  }

  // x轴label的旋转
  changeXAxisLabelRotate(chartOpt, xAxisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.xAxis[0].axisLabel.rotate = rotate;
    chartOpt.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }

  setSmallModeGrid(gridOption: EChartOption.Grid) {
    gridOption.top = grid.baseSmallPadding;
    gridOption.bottom = grid.baseSmallPadding;
    gridOption.left = grid.baseSmallPadding;
    gridOption.right = grid.baseSmallPadding;
  }

  setXaxisName(xAxisOption: EChartOption.XAxis[], name: string) {
    xAxisOption.forEach(e => {
      e.name = name;
    })
  }

  setYaxisName(yAxisOption: EChartOption.YAxis[], names: string[]) {
    for (let i = 0; i < yAxisOption.length && i < names.length; i++) {
      yAxisOption[i].name = names[i];
    }
  }
  setYnameGap(yAxisOption: EChartOption.YAxis[], yNameGap: number) {
    yAxisOption.forEach(e => {
      e.nameGap = yNameGap;
    });
  }

  setLegendPosition(gridOption: EChartOption.Grid, legendOption, legendPosition: string) {
    let style = this.commonService.changeFontSize();
    switch (legendPosition) {
      case "top":
        legendOption.show = false;
        break;
      case "right":
        gridOption['top'] = style.rightLegendGrid.top;
        gridOption['right'] = style.rightLegendGrid.right;
        gridOption['left'] = style.rightLegendGrid.left;
        gridOption['bottom'] = style.rightLegendGrid.bottom;

        // delete legendOption.width;
        legendOption['top'] = '14%';
        // legendOption['top'] = 0;
        legendOption['right'] = 0;
        legendOption['bottom'] = gridOption.bottom;
        legendOption['width'] = gridOption.right;
        legendOption['orient'] = "vertical";
        legendOption['pageIcons'] = {
          vertical: [
            "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
            "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
          ],
        };
        legendOption['textStyle']['padding'] = [2, 0, 0, 0];
        break;
      default:
        gridOption.bottom = legend.bottomLegendHeight;
        break;
    }
  }

  changeChartTitleDark(component: BasicBarLineComponent, darkMode: boolean) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  xAxisDarkMode(xAxisOption: EChartOption.XAxis[]) {
    xAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
    });
  }

  yAxisDarkMode(yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
      if (isNil(e['splitLine'])) {
        e['splitLine'] = {
          lineStyle: {
            color: color.darkModeTextColor
          }
        };
      } else {
        if (isNil(e['splitLine']['lineStyle'])) {
          e['splitLine']['lineStyle'] = {
            color: color.darkModeTextColor
          }
        } else {
          e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
        }
      }
    });
  }

  colorsDarkMode(colors: string[]) {
    colors.length = 0;
    color.darkModeColors.forEach(e => {
      colors.push(e);
    });
  }
  // 获取tooltip
  getDefaultTooltip() {
    let tooltip: EChartOption.Tooltip = this.chartOptionService.getDefaultTooltip();
    tooltip.axisPointer.type = 'shadow';
    return tooltip;
  }

  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    });
  }

  legendDarkMode(legendOption) {
    if (isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }

  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
  }

  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }

  getDefaultLineSeries() {
    let seriesOption: EChartOption.Series = this.chartOptionService.getDefaultLineSeries();
    seriesOption['yAxisIndex'] = 1;
    return seriesOption;
  }

  getDefaultBarSeries() {
    let seriesOption: EChartOption.Series = this.chartOptionService.getDefaultBarSeries();
    seriesOption['yAxisIndex'] = 0;
    return seriesOption;
  }


  buildSeries(chartData: any, seriesList: EChartOption.Series[], xAxisOption: EChartOption.XAxis[], lineSeriesOption: EChartOption.Series, barSeriesOption: EChartOption.Series) {
    seriesList.length = 0;
    if (chartData && chartData.hasOwnProperty('seriesName')) {
      for (let i = 0; i < chartData.seriesName.length; i++) {
        if (chartData.seriesName[i].type === "line") {
          let lineSeries: EChartOption.Series = cloneDeep(lineSeriesOption);
          lineSeries['name'] = chartData.seriesName[i].name;
          lineSeries['symbol'] = series.symbols[i % series.symbols.length];
          lineSeries['data'] = chartData.yData[i];
          seriesList.push(lineSeries);
        } else {
          let barSeries: EChartOption.Series = cloneDeep(barSeriesOption);
          barSeries['name'] = chartData.seriesName[i].name;
          barSeries['data'] = chartData.yData[i];
          barSeries['barGap'] = '0'
          seriesList.push(barSeries);
        }
      }
    }
    if (chartData && chartData.hasOwnProperty('xData')) {
      xAxisOption.forEach(e => {
        e.data = chartData.xData;
      });
    }
  }

  getChartxAxis() {
    let xAxisOption: EChartOption.XAxis[] = this.chartOptionService.getChartxAxis(1);
    xAxisOption.forEach(e => {
      e['boundaryGap'] = true;
    });
    return xAxisOption;
  }

  setInterval(option: any, interval: Number) {
    option.xAxis[0].axisLabel.interval = interval;
  }

  topLegendChange(legendDatas: any[], optionInit: ECharts) {
    legendDatas.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }

  setYAxisMin(yAxisOption: EChartOption.YAxis[], min: number[]) {
    yAxisOption.forEach((e, i) => {
      e.min = min[i]
    })
  }

  setYAxisMax(yAxisOption: EChartOption.YAxis[], max: number[]) {
    yAxisOption.forEach((e, i) => {
      e.max = max[i]
    })
  }

  setYAxisInterval(yAxisOption: EChartOption.YAxis[], interval: number[]) {
    yAxisOption.forEach((e, i) => {
      e.interval = interval[i]
    })
  }

  setYAxisSplitLine(yAxisOpttion: EChartOption.YAxis[], splitLineShow: boolean) {
    yAxisOpttion.forEach(e => {
      e.splitLine.show = splitLineShow;
    })
  }

  setUnit(chartTooltip: EChartOption.Tooltip, units: string[]) {
    chartTooltip.formatter = (params: EChartOption.Tooltip.Format[]) => {
      let str = "";
      if (params.length > 0) {
        str += "<span>" + params[0].name + "<span><br/>";
        params.forEach((element, i) => {
          if (isNil(element.data)) {
            str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
            str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + "--" + " " + units[i] + "</b><br/>";
          } else {
            str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
            str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + element.data + " " + units[i] + "</b><br/>";
          }
        });
      }
      return str;
    }
  }
}
